import { effects } from "redux-saga"
import appSagas from "./app/appSaga"
import languageSwitcherSagas from "./languageSwitcher/languageSwitcherSaga"
import sagaHome from "./sagaHome/sagaHomeSaga"
import sagaBlog from "./sagaBlog/sagaBlogSaga"
import sagaAuth from "./sagaAuth/sagaAuthSaga"
import sagaBooking from "./sagaBooking/sagaBookingSaga"
import sagaContact from "./sagaContact/sagaContactSaga"
import sagaMap from "./sagaMap/sagaMapSaga"
import sagaCart from "./sagaCart/sagaCartSaga"
import sagaPayment from "./sagaPayment/sagaPaymentSaga"

export default function* rootSaga() {
  yield effects.all([
    appSagas(),
    sagaHome(),
    sagaBlog(),
    languageSwitcherSagas(),
    sagaAuth(),
    sagaBooking(),
    sagaContact(),
    sagaMap(),
    sagaCart(),
    sagaPayment()
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas.ts